<ng-container *ngIf="displayedColumns$ | async as displayedColumns">
  <ng-container *ngIf="displayedColumnNames$ | async as displayedColumnNames">
    <ng-container *ngIf="columnWidth$ | async as columnWidth">
      <ng-container *ngIf="verticalAlignment$ | async as verticalAlignment">
        <ng-container *ngIf="columnSortable$ | async as columnSortable">
          <ng-container *ngIf="template$ | async as template">
            <ng-container *ngIf="dataSource$ | async as dataSource">
              <table
                cdkDropList
                (cdkDropListDropped)="onCdkDrop($event)"
                [cdkDropListData]="dataSource"
                mat-table
                matSort
                [dataSource]="dataSource"
                [trackBy]="trackByFunction"
                [attr.data-testid]="testId"
              >
                <ng-container *ngFor="let templateData of template | keyvalue" [matColumnDef]="templateData.key">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    [disabled]="!columnSortable[templateData.key]"
                    [style.width]="columnWidth[templateData.key]"
                  >
                    {{ displayedColumns[templateData.key] }}
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let data; let index = index"
                    [style.width]="columnWidth[templateData.key]"
                    [style.vertical-align]="verticalAlignment[templateData.key]"
                    [class.bg-darker]="darkRowBackgroundFn(data)"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        templateData.value || defaultTemplate;
                        context: { $implicit: templateData.key.startsWith('.') ? data : data[templateData.key], order: index, row: data }
                      "
                    ></ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="dragHandle">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width]="'64px'" disabled="true"></th>
                  <td
                    mat-cell
                    *matCellDef="let data"
                    class="drag-cell"
                    [style.width]="'64px'"
                    [class.bg-darker]="darkRowBackgroundFn(data)"
                  >
                    <ng-container *ngIf="data.draggable === undefined || data.draggable === true">
                      <p
                        *ngIf="!disableDragAndDropTooltipMessage; else disabledHandle"
                        cdkDragHandle
                        cdkDrag
                        cdkDragRootElement="[mat-row]"
                        (click)="onDragHandleClicked($event)"
                      >
                        <svg-icon key="reorder" size="md"></svg-icon>
                      </p>
                      <ng-template #disabledHandle>
                        <p class="disabled" [matTooltip]="disableDragAndDropTooltipMessage" matTooltipClass="custom-tooltip">
                          <svg-icon key="reorder" size="md"></svg-icon>
                        </p>
                      </ng-template>
                    </ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="moveToTop" *ngIf="!disableMoveToTop">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width]="'64px'" disabled="true"></th>
                  <td
                    mat-cell
                    *matCellDef="let data"
                    class="move-to-top-cell"
                    [style.width]="'64px'"
                    [class.bg-darker]="darkRowBackgroundFn(data)"
                  >
                    <ng-container
                      *ngIf="
                        ((dataSource[0].type === 'HeroSpotlight' && data.order > 2) ||
                          (dataSource[0].type !== 'HeroSpotlight' && data.order > 1)) &&
                        (data.draggable === undefined || data.draggable === true)
                      "
                    >
                      <p *ngIf="!disableDragAndDropTooltipMessage; else disabledHandle">
                        <svg-icon key="move-to-top" size="md" (click)="moveToTop($event, data)"></svg-icon>
                      </p>
                      <ng-template #disabledHandle>
                        <p class="disabled" [matTooltip]="disableDragAndDropTooltipMessage" matTooltipClass="custom-tooltip">
                          <svg-icon key="move-to-top" size="md"></svg-icon>
                        </p>
                      </ng-template>
                    </ng-container>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnNames"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumnNames"
                  (click)="onRowClick($event, row)"
                  [class.clickable]="!!onRowClickFn"
                ></tr>
              </table>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template let-data #defaultTemplate>{{ data }}</ng-template>
